import React from "react";
import LoadComponentBasedOnVisibility from "../components/LoadComponentBasedOnVisibility/index.js";

const ComponentVisibilityHOC = (WrappedComponent) => {
    class renderHOC extends React.Component {
        render() {
            return (
                <LoadComponentBasedOnVisibility
                    {...this.props}
                    WrappedComponent={WrappedComponent}
                />
            );
        }
    }
    return renderHOC;
};
export default ComponentVisibilityHOC;
